<script setup>
import { ProgressIndicator, ProgressRoot, useForwardProps } from "reka-ui";
import { computed } from "vue";

const props = defineProps({
  modelValue: { type: Number, default: 0 },
  max: { type: Number, default: 100 },
  getValueLabel: { type: Function, default: undefined },
  asChild: { type: Boolean, default: false },
});

const forwarded = useForwardProps(props);

const fillPercent = computed(() => ((props.modelValue ?? 0) / props.max) * 100);
</script>

<template>
  <ProgressRoot v-bind="forwarded" class="progress-bar">
    <ProgressIndicator
      class="indicator"
      :style="{ transform: `translateX(-${100 - fillPercent}%)` }"
    />
  </ProgressRoot>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;

.progress-bar {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 6px;
  background-color: c.$grey-lighter;
  border-radius: 3px;
}

.indicator {
  width: 100%;
  height: 100%;
  background-color: c.$main;
}
</style>
